import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCircleInfo: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="circle-info, info circle, tooltip, information"
    >
      <path
        d="M11 11H12V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M11.5 7.25H11.25V7.5V8.5V8.75H11.5H12.5H12.75V8.5V7.5V7.25H12.5H11.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </CentralIconBase>
  );
};

export default IconCircleInfo;
